import { Action } from "redux";
import { SeverityGroup } from "../model";

export const GET_SEVERITY_GROUPS = "GET_SEVERITY_GROUPS";


export interface SeverityGroupsAction extends Action<string> {
    severityGroups: SeverityGroup[];
}